// import Banner from './Banner';
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import {
    Form,
    Statistic,
    Select,
    Card,
    Button,
    Row,
    Col,
    DatePicker,
    Space,
    Tooltip,
    Modal,
    Input,
    Table,
} from "antd";
import { LockOutlined } from "@ant-design/icons";
import { PASSWORD_REGEX, PASSWORD_ERR_MSG } from "../../constants/constants";
import openNotification from "../../components/Notification/Notificaiton";

import moment from "moment";
import agent from "../../agent";
import {
    REPORT,
    REPORT_RESET,
    PASSWORD_UPDATE,
} from "./../../constants/actionTypes";
const { RangePicker } = DatePicker;

const dateFormat = "DD-MM-YYYY";
const { Option } = Select;

const selectData = ["Contains"];
const mapStateToProps = (state) => ({
    report: state.report,
    currentUser: state.common.currentUser,
});

const mapDispatchToProps = (dispatch) => ({
    getReport: (query) =>
        dispatch({
            type: REPORT,
            payload: agent.Report.getReport(query),
        }),
    resetReport: (query) =>
        dispatch({
            type: REPORT_RESET,
            payload: {},
        }),
});

class Report extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            btnSize: "small",
            // modalVisible: true,
            modalVisible: false,
            passwordValue: null,
            confirmPasswordValue: null,
            type: "month",
            data: { date: "Date", month: "Month", year: "Year" },
            dataLen: { date: 30, month: 12, year: 5 },
            dateRange: [],
            isOnLoad: true,
        };
        this.formRef = React.createRef();
    }

    handleClickReset = () => {
        this.props.form.resetFields();
    };

    handleOnChange = (e) => {

        if (e.target.id === "resetPassword_password") {
            this.setState({
                passwordValue: e.target.value,
            });
        } else {
            this.setState({
                confirmPasswordValue: e.target.value,
            });
        }
    };
    handleChange = (type, val) => {
        if (type === "dateRange" && val === null) {
            val = [];
        }
        this.setState({ [type]: val });
    };

    handleSubmitClick = async (e) => {
        if (this.state.passwordValue === this.state.confirmPasswordValue) {
            let payload = {
                type: "resetPassword",
                newPassword: this.state.passwordValue,
            };

            // await this.props.resetPassword(this.props.currentUser.uuid, payload);
            let response = await agent.User.update(
                this.props.currentUser.uuid,
                payload
            );
            console.log("kt response", response);

            console.log("kt", this.props.users);
            if (response && response.status && response.status === 400) {
                openNotification({
                    type: "error",
                    message: "Alert",
                    description: response.message,
                });
                this.setState({
                    modalVisible: true,
                });
            } else {
                openNotification({
                    type: "success",
                    message: "Update complete.",
                    description: "Your password have been updated.",
                });
                this.setState({
                    modalVisible: false,
                });

                // "notified", "reset", "normal"
                localStorage.setItem("reset", "normal");
            }
        }
    };

    componentWillReceiveProps(nextProps) {
        if (this.props !== nextProps && nextProps.currentUser) {
            if (
                (localStorage.getItem("reset") &&
                    localStorage.getItem("reset").toString() === "reset" &&
                    nextProps.currentUser.isResetPassword.toString() === "1") ||
                nextProps.currentUser.password_date < 0
            ) {
                this.setState({
                    modalVisible: true,
                });
            }
            if (
                nextProps.currentUser &&
                nextProps.currentUser.password_date < 7 &&
                this.state.notified === false &&
                localStorage.getItem("reset").toString() !== "notified"
            ) {
                openNotification({
                    type: "success",
                    message: "Alert",
                    description: `Your password will be expired in ${nextProps.currentUser.password_date} days, please update your password.`,
                });
                this.setState({
                    notified: true,
                });
                localStorage.setItem("reset", "notified");
            }
        }
    }

    componentDidMount() {
        this.getData();
    }

    getData = () => {
        const format = { date: "YYYY-MM-DD", month: "YYYY-MM", year: "YYYY" };
        const formatSuffix = [
            {
                date: " 00:00:00",
                month: "-01 00:00:00",
                year: "-01-01 00:00:00",
            },
            {
                date: " 23:59:59",
                month: "-30 23:59:59",
                year: "-12-31 23:59:59",
            },
        ];
        let isOnLoad = this.state.isOnLoad;

        if (this.state.dateRange.length < 2 && !isOnLoad) {
            openNotification({
                type: "error",
                message: "Alert",
                description: `Please fill in the date range.`,
            });
            this.props.resetReport();
        } else {
            let startDate = this.state.dateRange[0];
            let endDate = this.state.dateRange[1];
            let searchType = this.state.type;

            if (isOnLoad === true) {
                startDate = moment().startOf("year");
                endDate = moment().endOf("year");
                searchType = "month";
            }

            var dateRange = {
                from:
                    startDate &&
                    startDate.format(
                        `${format[searchType]}${formatSuffix[0][searchType]}`
                    ),
                to:
                    endDate &&
                    endDate.format(
                        `${format[searchType]}${formatSuffix[1][searchType]}`
                    ),
            };
            this.props.resetReport();
            this.setState({ isOnLoad: false });
            this.props.getReport({ type: searchType, ...dateRange });
        }
    };

    render() {
        const { size } = this.props;
        var { type, data, dataLen } = this.state;
        var { report } = this.props;

        const columns = [
            {
                title: data[type],
                dataIndex: "date",
                key: "date",
                sorter: (a, b) => a.date > b.date,
                sortDirections: ["descend", "ascend", "descend"],
                defaultSortOrder: "descend",
            },
            {
                title: "No of Search",
                dataIndex: "no_of_search",
                key: "no_of_search",
            },
            {
                title: "Total Download",
                dataIndex: "total_download",
                key: "total_download",
            },
            {
                title: "Download",
                children: [
                    {
                        title: "XML",
                        dataIndex: "download_xml",
                        key: "download_xml",
                    },
                    {
                        title: "CSV",
                        dataIndex: "download_csv",
                        key: "download_csv",
                    },
                    {
                        title: "JSON",
                        dataIndex: "download_json",
                        key: "download_json",
                    },
                ],
            },
            {
                title: "API",
                children: [
                    {
                        title: "XML",
                        dataIndex: "api_xml",
                        key: "api_xml",
                    },
                    {
                        title: "CSV",
                        dataIndex: "api_csv",
                        key: "api_csv",
                    },
                    {
                        title: "JSON",
                        dataIndex: "api_json",
                        key: "api_json",
                    },
                ],
            },
        ];

        const dataRow = [];
        for (let i = 0; i < dataLen[type]; i++) {
            var date = "";
            switch (type) {
                case "date":
                    date = `${(i < 9 ? "0" : "") + (i + 1)}-08-2021`;
                    break;
                case "month":
                    date = `${(i < 9 ? "0" : "") + (i + 1)}-2021`;

                    break;
                case "year":
                    date = `20${i + 17}`;

                    break;

                default:
                    break;
            }
            dataRow.push({
                key: i + 1,
                hash: i + 1,
                date: date,
                no_of_search: `${i + 6}`,
                total_download: `${(i + 1) * 3}`,
                download_xml: `${i + 1}`,
                download_csv: `${i + 1}`,
                download_json: `${i + 1}`,
                api_xml: `${i + 1}`,
                api_csv: `${i + 1}`,
                api_json: `${i + 1}`,
            });
        }

        function PickerWithType({ type, dateRange, onChange }) {
            var format = "";
            switch (type) {
                case "date":
                    format = "DD-MMM-YYYY";
                    break;
                case "month":
                    format = "MMM YYYY";
                    break;
                case "year":
                    format = "YYYY";
                    break;

                default:
                    break;
            }
            // if (type === 'period') return <RangePicker
            //   placeholder={["Start Period", "End Period"]}
            //   // defaultValue={[moment('2015/01/01', dateFormat), moment('2015/01/01', dateFormat)]}
            //   format={dateFormat}
            // />
            // return <DatePicker picker={type} onChange={onChange} format={format} />;
            return (
                <RangePicker
                    placeholder={["Start " + type + "", "End " + type + ""]}
                    picker={type}
                    onChange={onChange}
                    format={format}
                    value={dateRange}
                />
            );
        }

        function SwitchablePicker({ handleChange, dateRange, type }) {
            return (
                <Space wrap={true}>
                    {/* <Select value={type} onChange={setType} style={{ width: '180px' }}> */}
                    <Select
                        value={type}
                        onChange={(val) => {
                            handleChange("type", val);
                        }}
                        style={{ width: "180px" }}
                    >
                        <Option value="date">Daily</Option>
                        {/* <Option value="week">Weekly</Option> */}
                        <Option value="month">Monthly</Option>
                        <Option value="year">Yearly</Option>
                        {/* <Option value="period">Period</Option> */}
                    </Select>
                    {/* <PickerWithType type={type} onChange={value => console.log(value[0].format('YYYY-MM-DD 00:00:00'))} /> */}

                    <PickerWithType
                        type={type}
                        dateRange={dateRange}
                        onChange={(value) => {
                            // console.log({
                            //   dateRange: {
                            //     from: value[0].format(`${format[type]}${formatSuffix[0][type]}`),
                            //     to: value[1].format(`${format[type]}${formatSuffix[1][type]}`)
                            //   }
                            // })
                            handleChange("dateRange", value);
                            // handleChange('dateRange', {
                            //   from: value[0],//.format(`${format[type]}${formatSuffix[0][type]}`),
                            //   to: value[1]//.format(`${format[type]}${formatSuffix[1][type]}`)
                            // })
                        }}
                    />
                    {/* <PickerWithType type={type} onChange={value => ({
            dateRange: {
              from: value[0].format(`${format[type]}${formatSuffix[0][type]}`),
              to: value[1].format(`${format[type]}${formatSuffix[1][type]}`)
            }
          })} /> */}
                </Space>
            );
        }

        return (
            <React.Fragment>
                <div className="grid height_100 ">
                    <Card
                        size={this.state.btnSize}
                        className="height_100"
                        title={<h1>Report</h1>}
                    >
                        <Form
                            ref={this.formRef}
                            name="conditionsForm"
                            onFinish={this.handleOnFinish}
                            onFinishFailed={this.props.onFinishFailed}
                            // size={size}
                        >
                            <Row gutter={[8, 0]} justify="end" align="top">
                                <Col>
                                    <Form.Item name="datepicker">
                                        <SwitchablePicker
                                            type={type}
                                            dateRange={this.state.dateRange}
                                            handleChange={this.handleChange}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col>
                                    <Form.Item style={{ paddingTop: "3px" }}>
                                        <Tooltip
                                            placement="bottom"
                                            title="Get result"
                                        >
                                            <Button
                                                type="primary"
                                                htmlType="submit"
                                                block
                                                onClick={this.getData}
                                            >
                                                {" "}
                                                Get result{" "}
                                            </Button>
                                        </Tooltip>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>

                        <Table
                            size={size}
                            // dataSource={dataRow}
                            dataSource={report.data}
                            columns={columns}
                            bordered={true}
                            pagination={{
                                simple: false,
                                showTotal: (total, range) =>
                                    `${range[0]}-${range[1]} of ${total} items`,
                                total: (report.data || []).length, // setting page value
                                // total: dataLen[type],// setting page value
                                showSizeChanger: true,
                                // pageSize: 30,
                                pageSizeOptions: [10, 25, 50, 100],
                            }}
                            scroll={{ y: "calc(100vh - 62vh)" }}
                        />
                    </Card>
                </div>

                <Modal
                    title="Reset Password"
                    centered
                    closable={false}
                    visible={this.state.modalVisible}
                    footer={[
                        <Button
                            key="submit"
                            type="primary"
                            disabled={
                                !this.state.passwordValue ||
                                !this.state.confirmPasswordValue
                            }
                            onClick={(e) => this.handleSubmitClick(e)}
                        >
                            Submit
                        </Button>,
                    ]}
                >
                    <Form name="resetPassword" layout="vertical">
                        <Form.Item
                            name="password"
                            rules={[
                                {
                                    required: true,
                                    message: "Please input your password!",
                                },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (
                                            !value ||
                                            PASSWORD_REGEX.test(
                                                value.toString()
                                            )
                                        ) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(
                                            new Error(PASSWORD_ERR_MSG)
                                        );
                                    },
                                }),
                            ]}
                            onChange={(e) => this.handleOnChange(e)}
                            hasFeedback
                        >
                            <Input.Password
                                value={this.state.passwordValue}
                                placeholder="New Password"
                                prefix={
                                    <LockOutlined className="site-form-item-icon" />
                                }
                            />
                        </Form.Item>
                        <Form.Item
                            name="confirm_password"
                            onChange={(e) => this.handleOnChange(e)}
                            hasFeedback
                            rules={[
                                {
                                    required: true,
                                    message: "Please confirm your password!",
                                },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (
                                            !value ||
                                            getFieldValue("password") === value
                                        ) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(
                                            new Error(
                                                "The two passwords that you entered do not match!"
                                            )
                                        );
                                    },
                                }),
                            ]}
                        >
                            <Input.Password
                                value={this.state.confirmPasswordValue}
                                placeholder="Confirm Password"
                                prefix={
                                    <LockOutlined className="site-form-item-icon" />
                                }
                                dependencies={["password"]}
                            />
                        </Form.Item>
                    </Form>
                </Modal>
            </React.Fragment>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Report);



// WEBPACK FOOTER //
// src/layouts/views/report.js